import React from "react";
import { useTranslation } from "react-i18next";

export default function Process() {
  const { t } = useTranslation();
  const STEPS = [
    { n: "01", t: t("home.step1_t"), d: t("home.step1_d") },
    { n: "02", t: t("home.step2_t"), d: t("home.step2_d") },
    { n: "03", t: t("home.step3_t"), d: t("home.step3_d") },
    { n: "04", t: t("home.step4_t"), d: t("home.step4_d") },
  ];
  return (
    <div className="max-w-7xl mx-auto px-6 lg:px-10 py-20">
      <div className="overline mb-4">{t("nav.process", "Process")}</div>
      <h1 className="font-serif text-5xl md:text-6xl text-zinc-950 tracking-tight max-w-4xl">{t("process.title", "Our Recruitment Process")}</h1>
      <p className="mt-6 text-lg text-zinc-900 max-w-3xl">{t("process.subtitle")}</p>

      <div className="mt-14 space-y-4">
        {STEPS.map((s) => (
          <div key={s.n} className="grid grid-cols-1 md:grid-cols-12 gap-6 border border-zinc-200 rounded-3xl p-8 card-lift">
            <div className="md:col-span-2 font-serif text-4xl text-[#b8860b]">{s.n}</div>
            <div className="md:col-span-3 font-serif text-2xl text-zinc-950">{s.t}</div>
            <div className="md:col-span-7 text-zinc-900 leading-relaxed">{s.d}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
